import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MetadataDrivenParser from 'gw-portals-driven-ui-js/MetadataDrivenParser';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';

const fn = ($scope, MetadataDrivenUIService, StateUtils, submissionViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    const submissionVM = submissionViewModel({'Binding': true});

    const parseIterableMetadata = async (presentationMetadataIdentifier, iterableMetadataSuffix, pathToVM) => {
        // e.g. for drivers iterable
        const metadataForIterable = await MetadataDrivenUIService.getPresentationMetadata(`${presentationMetadataIdentifier}-${iterableMetadataSuffix}`);
        const iterablesArrayVM = _.get(submissionVM, pathToVM);

        const iterablesComponents = iterablesArrayVM.children
            .map(elemVM => {
                // parse content adds items to 'metadataForIterable' (side-effect)
                // so the last iteration would override the first
                const metadataClone = Object.assign({}, metadataForIterable);
                const parsedMetadataField = new MetadataDrivenParser(metadataClone, elemVM).parsePageContent();
                return {
                    viewModel: elemVM,
                    parsedMetadata: parsedMetadataField
                };
            });

        return iterablesComponents;
    };

    ctrl.init = () => {
        ctrl._setBindDataDefaultValues();

        $scope.bindData = submissionVM.bindData;
        $scope.submissionVM = submissionVM;
        $scope.lobData = submissionVM.lobData.value;
        $scope.loading = true;

        const presentationMetadataIdentifier = 'quoteandbind-pa.{SEGMENT}.additionalInfo';
        MetadataDrivenUIService.getPresentationMetadata(presentationMetadataIdentifier)
            .then(pagePresentationMetadata => {
                const vmAndMetadataPromises = Object.getOwnPropertyNames(pagePresentationMetadata.iterables || {})
                    .map(iterableType => _.get(pagePresentationMetadata, `iterables.${iterableType}`))
                    .map(({path, metadataSuffix}) => parseIterableMetadata(presentationMetadataIdentifier, metadataSuffix, path));

                return Promise.all(vmAndMetadataPromises)
                    .then(vmAndMetadataResults => {
                        const additionalPresentationMetadata = new MetadataDrivenParser(pagePresentationMetadata, submissionVM).parsePageContent();
                        const viewModelAndPresentationMetadataArray = [{viewModel: submissionVM, parsedMetadata: additionalPresentationMetadata}]
                            .concat(_.flatten(vmAndMetadataResults));

                        ctrl._setCtrlParam('presentationDataArrays', viewModelAndPresentationMetadataArray);
                        ctrl._setCtrlParam('presentationData', pagePresentationMetadata);
                        ctrl._setCtrlParam('loading', false);
                    });
            });
    };

    ctrl._setBindDataDefaultValues = () => {
        submissionVM.bindData.value = submissionVM.bindData.value || {};
        if (!submissionVM.bindData.billingAddress.value) {
            submissionVM.bindData.billingAddress.value = {};
            angular.copy(
                submissionVM.baseData.policyAddress.value,
                submissionVM.bindData.billingAddress.value
            );
        }
        submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
        submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value ||
            submissionVM.baseData.accountHolder.emailAddress1.value;
    };

    ctrl._validateSubmission = () => !(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid);

    ctrl.next = function (callback) {
        callback(submissionVM);
    };

    ctrl._setCtrlParam = ComponentUtil.setCtrlParam(ctrl, $scope);

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'MetadataDrivenUIService', 'StateUtils', 'submissionViewModel'];

export default fn;
